import { Button } from '#atoms';
import { SetStateAction } from 'react';
import styled from 'styled-components';
import { Container, Label } from './styles';

interface ClinicalDataManagerProps {
  onClose: () => void;
}

export const ClinicalDataModal = ({ onClose }: ClinicalDataManagerProps) => {
  return (
    <Container>
      <Label>임상 데이터 관리</Label>
      <Button size="sm">트레이닝 성과 만들기</Button>
      <Button size="sm" background="anti" style={{ color: '#e13a3a' }}>
        데이터 삭제
      </Button>
      <Button size="sm" background="transparent" onClick={onClose}>
        닫기
      </Button>
    </Container>
  );
};
